module.exports = __webpack_public_path__ + "img/发布年份.86694e32.png";